/**
 * Subclass of ModalShare from modal_share.js. Uses prototypical inhertance to
 * overwrite functions. Specific to the new list page modal share (and new list
 * page modal player modal share)
 *
 * Config file should include the following properties:
 * @btnShare <selector> - Selector of the share button that should open the modal
 * @parentEl <selector> - Parent element/container that encapsulates share button(s)
 * @el <selector> - The parent modal element (usually an id)
*/

/**
 * Constructor for ModalShare object used on new list page
*/
import ModalShare from './modal_share'

function ListPageModalShare (config) {
  this.config = config;
  config && this.init();
}

// Set up prototypal inheritance.
ListPageModalShare.prototype = new ModalShare();

/**
 * Set up list-page-specific bindings
*/
ListPageModalShare.prototype.bindCustomModalEvents = function() {
  // Prevent clicks in modal-popup from closing modal
  this.$container.find('.j-modal-content').click(function(e) {
    e.stopPropagation();
  });
};

/**
 * Binds all the share thumbnail button(s) within the parent container.
 * Overrides dummy function in superclass
*/
ListPageModalShare.prototype.bindModalToShareButtons = function() {
  var that = this;
  var isTitlesRemoved = false;
  var $content = this.$container.find('.j-modal-popup');
  var data = {};

  // Bind all slideshow share buttons to open modal
  $(this.config.parentEl).on('click', this.config.btnShare, function(e) {
    e.stopPropagation();
    var $slideshow = $(this).closest('.iso_slideshow');

    $content.hide();
    that.$container.fadeIn(200);

    data = {
      "authorId": $slideshow.data("slideshowauthorid"),
      "embedCode": $slideshow.data("embedcode"),
      "totalSlides": $slideshow.data("totalslides"),
      "ssLink": $slideshow.data("sslink"),
      "title": $slideshow.data("title"),
      "ssType": $slideshow.data("sstype"),
      "ssId": $slideshow.data("slideshowid"),
      "social": {
        "linkedin": $slideshow.data("linkedinshareurl"),
        "facebook": $slideshow.data("facebookshareurl"),
        "twitter": $slideshow.data("twittershareurl"),
        "pinterest": $slideshow.data("pinterestshareurl"),
        "wordpress": $slideshow.data("wordpressshareurl"),
        "email": 'mailto:?subject=Check out this SlideShare ' +
            $slideshow.data("sstypeasstring") + '&body=' +
            $slideshow.data("sslink")
      }
    };
    that.data = data;
    $content.show();
    that.show();
    that.adjustShareModalTop();

    that.$linkURLInput.val(that.data.ssLink);
    that.renderDefaultEmbedOptions();
    that.renderSlideStartOptions();
    if(!isTitlesRemoved) {
      $('.iso_slideshow_link').attr('title', '');
      isTitlesRemoved = true;
    }
    e.preventDefault();
  });
};

/**
 * Close the modal.
*/
ListPageModalShare.prototype.close = function() {
  this.reset();
  this.$container.hide();
  this.shareGATracking('modalClose');
};

ListPageModalShare.prototype.adjustShareModalTop = function(){
  var $modal_share = $("#homepage-modal-share, #new-list-modal-share");
  var $modal_popup = $modal_share.find('.j-modal-popup');
  $modal_share.length > 0 && $modal_popup.length > 0 &&
    $modal_popup.animate({top: (($modal_share.height() - $modal_popup.height()) / 2) + "px"}, 400);
};

export default ListPageModalShare;